import { hasDataLayer } from '@utils/dataLayer';

export const articlePartPrev = async (chapter: number) => {
  if (hasDataLayer()) {
    if (window.didomiOnReady !== undefined) {
      await Promise.resolve(
        window.dataLayer.push({
          event: 'articlePart_previous',
          article: { part: chapter.toString() },
        })
      );
    }
  }
};

export const articlePartNext = async (chapter: number) => {
  if (hasDataLayer()) {
    if (window.didomiOnReady !== undefined) {
      await Promise.resolve(
        window.dataLayer.push({
          event: 'articlePart_next',
          article: { part: chapter.toString() },
        })
      );
    }
  }
};
